var postSlideshow = require('./post-slideshow');

jQuery(document).ready(function ($) {
  
  

  
  
  
  if(localStorage.getItem("iknowyou")) {
      $('.overlay').fadeOut();
    } else {
      
      localStorage.setItem("iknowyou", "true");
    }
  
  
  var hours = 1; // to clear the localStorage after 1 hour(if someone want to clear after 8hrs simply change hours=8)
var now = new Date().getTime();
var setupTime = localStorage.getItem('setupTime');
if (setupTime == null) {
    localStorage.setItem('setupTime', now)
} else {
    if(now-setupTime > hours*60*60*1000) {
        localStorage.clear()
        localStorage.setItem('setupTime', now);
    }
}
  
  
  
  
   });





  jQuery(document).ready(function ($) {
  
    $('.gallery').masonry({
    // options
    itemSelector: '.gallery-item',
    percentPosition: true
  });
   
$('.wpforms-recaptcha-container').hide();
$('#wpforms-82-field_2').on('input', function() {
        var textareaValue = $(this).val().trim(); // Получаем значение textarea и удаляем лишние пробелы
        if (textareaValue.length > 0) {
            $('.wpforms-recaptcha-container').show(); // Показываем блок .wpforms-recaptcha-container
        } else {
            $('.wpforms-recaptcha-container').hide(); // Скрываем блок .wpforms-recaptcha-container
        }
    });

    
    
    $('.wp-block-latest-posts__list a').hover(function() {
      $(this).parent().find('img').toggleClass('hover');
    
   
  }); 
   
    
    $('.mobile-menu').click(function() {
      
      $('.left-sidebare').fadeToggle(100);
    
   
  }); 

  function setupCarouselSliderPreview() {
    $('.cb-wrapper.swiper-wrapper').each(function() {
      var wrapper = this;
      var $wrapper = $(wrapper);
      var $slides = $wrapper.children('.swiper-slide, .cb-slide');
      var carousel = wrapper.parentElement;

      if (!carousel || !$slides.length) {
        return;
      }

      var gap = parseFloat($slides.first().css('margin-right')) || 0;
      var previewWidth = window.matchMedia('(max-width: 575.98px)').matches ? 64 : 100;
      var carouselWidth = carousel.clientWidth || $wrapper.parent().width();
      var slideWidth = Math.max(1, carouselWidth - previewWidth - gap);
      var swiper = carousel.swiper || wrapper.swiper;

      carousel.style.overflow = 'hidden';
      wrapper.style.setProperty('--cb-slide-width', slideWidth + 'px');

      if (swiper && swiper.params) {
        swiper.params.slidesPerView = 'auto';
        swiper.update();
      }

      if (!$wrapper.data('click-next-bound')) {
        $wrapper.on('click', '.swiper-slide, .cb-slide', function(event) {
          if ($(event.target).closest('a, button').length) {
            return;
          }

          var activeSwiper = carousel.swiper || wrapper.swiper;

          if (activeSwiper && typeof activeSwiper.slideNext === 'function') {
            activeSwiper.slideNext();
            setTimeout(setupCarouselSliderPreview, 400);
            return;
          }

          $(carousel).children('.swiper-button-next, .cb-button-next').trigger('click');
          setTimeout(setupCarouselSliderPreview, 400);
        });

        $wrapper.data('click-next-bound', true);
      }
    });
  }

  setupCarouselSliderPreview();
  setTimeout(setupCarouselSliderPreview, 300);
  setTimeout(setupCarouselSliderPreview, 1000);
  $(window).on('load', setupCarouselSliderPreview);
  $(window).on('resize', setupCarouselSliderPreview);
    
     
   
  
     
   
  

      
      
      
   
  
  function loader() {
      
      $("body").addClass('anim');
      
    }
    setTimeout(loader, 300);
  
  //$(".entry-content")

  
//  $(document).ready(function() {
//  if ($("body").hasClass("thumbnails-on")) {
//    $('html, body, *').mousewheel(function(e, delta) {
//    this.scrollLeft -= (delta);
//    e.preventDefault();
//  });
//}
//
//});
  
  
  

      
  
  $('.overlay').click(function() {
   
    $(this).fadeOut();
  });

  function setupPostSlideshow() {
    var $article = $('body.single-post article.post-slideshow-enabled').first();

    if (!$article.length || $article.data('post-slideshow-ready')) {
      return false;
    }

    var articleClasses = ($article.attr('class') || '').split(/\s+/);
    var articleTitle = $article.attr('data-post-title') || '';

    if (postSlideshow.isExhibitionViewsPost(articleClasses, articleTitle)) {
      return false;
    }

    var $entryContent = $article.children('.entry-content').first();
    var $contentBox = $entryContent.children('.content-box').first();
    var $postGallery = $entryContent.children('.post-gallery').first();
    var $deck = $('<div class="post-slideshow" tabindex="0" aria-live="polite"></div>');
    var $prevHover = $('<button class="post-slideshow-nav post-slideshow-nav--prev" type="button" aria-label="Previous slide"></button>');
    var $nextHover = $('<button class="post-slideshow-nav post-slideshow-nav--next" type="button" aria-label="Next slide"></button>');
    var $slides = $();

    function appendSlide($node, type) {
      var hasMedia = $node.find('img, video, iframe').length || $node.is('img, video, iframe');
      var hasText = $node.text().trim().length > 0;

      if (!hasMedia && !hasText) {
        return;
      }

      var $slide = $('<section class="post-slideshow-slide" aria-hidden="true"></section>');

      $slide.addClass('post-slideshow-slide--' + type);

      if (type === 'media') {
        $slide.append($('<div class="post-slideshow-media"></div>').append($node.detach()));
      } else {
        $slide.append($('<div class="post-slideshow-text"></div>').append($node.detach()));
      }

      $slides = $slides.add($slide);
    }

    $contentBox.children().each(function() {
      var $node = $(this);
      var isMediaGroup = $node.is('.wp-block-gallery, .wp-block-cb-carousel, .wp-block-cb-carousel-v2, .wp-block-cb-carousel-slider, .wp-block-cb-carousel-slider-v2');
      var $groupMedia = isMediaGroup ? $node.find('figure, .gallery-item').filter(function() {
        return $(this).find('img, video, iframe').length > 0;
      }) : $();

      if ($groupMedia.length) {
        $groupMedia.each(function() {
          appendSlide($(this), 'media');
        });
        $node.remove();
        return;
      }

      var hasMedia = $node.find('img, video, iframe').length || $node.is('img, video, iframe');
      var hasText = $node.text().trim().length > 0;
      var isMediaBlock = hasMedia && (!hasText || $node.is('.wp-block-image, .wp-block-gallery, .wp-block-cb-carousel, .wp-block-cb-carousel-v2, .wp-block-cb-carousel-slider, .wp-block-cb-carousel-slider-v2, figure'));

      appendSlide($node, isMediaBlock ? 'media' : 'text');
    });

    $postGallery.find('.gallery-item').each(function() {
      var $node = $(this);

      $node.removeAttr('style');
      appendSlide($node, 'media');
    });

    if (!$slides.length) {
      return false;
    }

    var currentSlide = 0;
    var wheelLocked = false;

    function showSlide(index) {
      currentSlide = postSlideshow.getWrappedSlideIndex(index, 0, $slides.length);

      $slides.removeClass('is-active').attr('aria-hidden', 'true');
      $slides.eq(currentSlide).addClass('is-active').attr('aria-hidden', 'false');
      $deck.attr('data-current-slide', currentSlide + 1);
    }

    function goToRelativeSlide(step) {
      showSlide(postSlideshow.getWrappedSlideIndex(currentSlide, step, $slides.length));
    }

    $deck.append($slides, $prevHover, $nextHover);
    $entryContent.prepend($deck);
    $contentBox.add($postGallery).hide().attr('aria-hidden', 'true');
    $article.addClass('post-slideshow-ready').data('post-slideshow-ready', true);
    $('body').addClass('post-slideshow-active');
    showSlide(0);

    $deck.on('wheel', function(e) {
      var deltaY = e.originalEvent.deltaY;

      if (!deltaY) {
        return;
      }

      e.preventDefault();

      if (wheelLocked) {
        return;
      }

      wheelLocked = true;
      goToRelativeSlide(deltaY > 0 ? 1 : -1);

      setTimeout(function() {
        wheelLocked = false;
      }, 450);
    });

    $deck.on('click', function(e) {
      if ($(e.target).closest('a, button, input, textarea, select, label').length) {
        return;
      }

      var bounds = this.getBoundingClientRect();
      var direction = postSlideshow.getSlideDirectionFromClientX(e.clientX, bounds.left, bounds.width);

      goToRelativeSlide(direction);
    });

    $prevHover.on('click', function(e) {
      e.stopPropagation();
      goToRelativeSlide(-1);
    });

    $nextHover.on('click', function(e) {
      e.stopPropagation();
      goToRelativeSlide(1);
    });

    $(document).on('keydown.postSlideshow', function(e) {
      if (e.which === 37) {
        goToRelativeSlide(-1);
        e.preventDefault();
      } else if (e.which === 39) {
        goToRelativeSlide(1);
        e.preventDefault();
      }
    });

    if (typeof Hammer !== 'undefined') {
      var deckHammer = new Hammer($deck[0]);

      deckHammer.on('swipeleft', function() {
        goToRelativeSlide(1);
      });

      deckHammer.on('swiperight', function() {
        goToRelativeSlide(-1);
      });
    }

    return true;
  }
  
    
    // Получите изображение и элементы модального окна
var postSlideshowActive = setupPostSlideshow();
var images = postSlideshowActive ? $() : $(".post-gallery .gallery img");
var modal = $("#modal");
var modalImage = $("#modal-image");
var modalClose = $("#close-modal");
var caption = $("#caption");
var currentIndex = 0;
var wheelLocked = false;

function getImageSrc(img) {
    var src = img.attr("src");
    var lazySrc = img.attr("data-src");
    var currentSrc = img.prop("currentSrc");

    if (currentSrc && currentSrc.indexOf("data:image/svg+xml") !== 0) {
        return currentSrc;
    }

    if (src && src.indexOf("data:image/svg+xml") !== 0) {
        return src;
    }

    return lazySrc || src || "";
}

// Предварительная загрузка всех изображений
var imgObjects = [];
images.each(function() {
    var src = getImageSrc($(this));
    if (!src) {
        return;
    }

    var imgObj = new Image();
    imgObj.src = src;
    imgObjects.push(imgObj);
});

// Когда пользователь нажимает на изображение, откройте модальное окно и отобразите изображение
images.click(function() {
    currentIndex = images.index(this);
    showImage($(this));
});

// Когда пользователь нажимает на изображение модального окна, закройте модальное окно
modalImage.click(function() {
    modal.hide();
    caption.empty();
});

modalClose.click(function() {
    modal.hide();
    caption.empty();
});

// Кнопки "Следующий" и "Предыдущий"
$("#next").click(function() {
    if (!images.length) {
        return;
    }

    currentIndex = (currentIndex + 1) % images.length;
     caption.empty();
    showImage($(images[currentIndex]));
 
});

$("#prev").click(function() {
    if (!images.length) {
        return;
    }

    currentIndex = (currentIndex - 1 + images.length) % images.length;
  caption.empty();
    showImage($(images[currentIndex]));
  
});

// Функция для отображения изображения в модальном окне
function showImage(img) {
    var src = getImageSrc(img);

    if (!src) {
        return;
    }

    modal.show();
    modalImage.attr("src", src);
    modalImage.attr("data-src", src);
    modalImage.attr("alt", img.attr("alt"));
    
    var figcaptionText = img.closest("figure").find("figcaption.wp-caption-text").html();
    caption.html(figcaptionText);
    var altText = img.attr('alt'); 
    var boldParagraph = '<p class="m-0"><strong>' + altText + '</strong></p>';
    caption.prepend(boldParagraph); 
   
}

function slideByWheel(deltaY) {
    if (wheelLocked || !modal.is(":visible")) {
        return;
    }

    wheelLocked = true;

    if (deltaY > 0) {
        $("#next").click();
    } else if (deltaY < 0) {
        $("#prev").click();
    }

    setTimeout(function() {
        wheelLocked = false;
    }, 450);
}

modal.on("wheel", function(e) {
    e.preventDefault();
    slideByWheel(e.originalEvent.deltaY);
});

// Обработчики событий клавиатуры
$(document).keydown(function(e) {
    switch(e.which) {
        case 37: // left arrow key
            $("#prev").click();
            break;
        case 39: // right arrow key
            $("#next").click();
            break;
        default: return;
    }
    e.preventDefault();
});
  // Подключите Hammer.js
if (typeof Hammer !== "undefined") {
var hammer = new Hammer(document.body);

// Обработчики событий свайпа
hammer.on("swipeleft", function() {
  $("#next").click();
});

hammer.on("swiperight", function() {
  $("#prev").click();
});
}
  
  
    
    
  
  
  
   });
